/**
 * @author gabyong.kim
 * @email gabyong.kim@gloovir.com
 * @create date 2023-10-19 12:02:30
 * @modify date 2023-10-19 12:02:30
 * @desc 로그인 메인 화면 정의
 */


import { Route, Routes, useNavigate } from "react-router-dom";
import { View, Text, ImageBackground } from "react-native";
import { FONT } from "../../value/staticValues";
//import { ReactComponent as BiImg } from "../../img/ico-etri-rep-cloud-bi.svg";
import { ReactComponent as BiImg } from "../../img/ico-fornax-bi-gradient.svg";

import { ReactComponent as ETRICiImg } from "../../img/ico-etri-ci.svg";
import LoginContainer from "./LoginContainer";
import { PAGE_URL } from "../../value/Url";
import ResetPwdContainer from "./resetPwd/ResetPwdContainer";
import ChangePwdContainer from "./changePwd/ChangePwdContainer";

//const image = { LoginBg: require("../../img/img-login-bg-1.png") };
const image = { LoginBg: require("../../img/img-login-bg-3.png") };


export default function LoginMainPage() {
    const navigate = useNavigate();

    return (
        <View style={{
            minWidth: 1350, height: "100vh"
        }}>
            {/* Header */}
            <div style={{
                width: "auto", height: 64,
                display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 0 6px 0 rgba(79, 95, 216, 0.3)",
                backgroundColor: "#fff"
            }}>
                <View style={{
                    marginRight: 1150,
                }}>
                    <BiImg style={{cursor: "pointer"}} onClick={() => {navigate(``)}}/>
                </View>
            </div>

            {/* Body */}

                <ImageBackground
                    source={image.LoginBg}
                    style={{
                        flex: 1, justifyContent: "center",
                        width: "100%", height: "100%"
                    }}
                    resizeMode={"cover"}
                >
                    <View style={{
                        alignItems: "center", justifyContent: "center", flex: 1,
                        minHeight: 600,
                    }}>
                        <Routes>
                            <Route path={`/`} element={<LoginContainer/>} />
                            <Route path={`${PAGE_URL.RESETPWD}`} element={<ResetPwdContainer/>} />
                            <Route path={`${PAGE_URL.CHANGEPWD}`} element={<ChangePwdContainer/>} />
                        </Routes>
                    </View>
                </ImageBackground>

            {/* Footer */}
            <View style={{
                position: "absolute",
                bottom: 0,
                alignItems: "center", justifyContent: "center", flexDirection: "row",
                width: "100%", height: 60
            }}>
                {/* <ETRICiImg style={{marginRight: 20}}/> */}
                <Text style={{
                    fontFamily: FONT.REGULAR,
                    fontSize: 12,
                    lineHeight: 16,
                    color: "#b9ddff",
                }}>
                    Copyright ⓒ GlooVir Inc. All rights reserved.
                </Text>
            </View>
        </View>
    )
}